/* eslint-disable react/prop-types */
import React from 'react';
import { Select, MenuItem, InputLabel, FormControl, TextField } from '@material-ui/core';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import { Autocomplete } from '@material-ui/lab';
import PropTypes from 'prop-types';

const useStyles = makeStyles({
  underlineLight: {
    '&::before': {
      borderBottom: '1px solid black !important',
      opacity: '0.3',
    },
  },
  underline: {
    '&::before': {
      borderBottom: '1px solid lightgray !important',
    },
  },
});

const CustomDropdown = props => {
  const {
    label,
    items,
    name,
    id,
    onChange,
    selectedValue,
    width,
    defaultValue,
    shrink,
    autoComplete,
    allowEmpty,
    emptyValues,
    disabled,
  } = props;
  const classes = useStyles();
  const theme = useTheme();

  if (autoComplete) {
    return (
      <FormControl style={{ width }}>
        <Autocomplete
          id={id}
          options={items}
          renderInput={params => <TextField {...params} label={label} />}
          onChange={onChange}
          value={selectedValue}
          data-testid="autocomplete"
        />
      </FormControl>
    );
  }

  return (
    <FormControl style={{ width }}>
      <InputLabel shrink={shrink} htmlFor={id} data-testid="dropdown_label">
        {label}
      </InputLabel>
      <Select
        value={selectedValue}
        defaultValue={defaultValue}
        onChange={onChange}
        style={{ textAlign: 'start' }}
        inputProps={{
          name,
          id,
          width,
        }}
        disabled={disabled}
        className={theme.palette.type === 'light' && !disabled ? classes.underlineLight : classes.underline}
        data-testid={`select_list_${id}`}
      >
        {/* eslint-disable react/jsx-one-expression-per-line */}
        {allowEmpty && <MenuItem value={emptyValues[0]}> {emptyValues[1]} </MenuItem>}
        {items.map(i => (
          <MenuItem value={i.id} key={i.id}>
            {i.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

CustomDropdown.propTypes = {
  label: PropTypes.string.isRequired,
  items: PropTypes.array.isRequired,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  id: PropTypes.string.isRequired,
  selectedValue: PropTypes.any,
  defaultValue: PropTypes.any,
  width: PropTypes.string.isRequired,
  shrink: PropTypes.bool,
  autoComplete: PropTypes.bool,
  allowEmpty: PropTypes.bool,
  emptyValues: PropTypes.array,
  disabled: PropTypes.bool,
};

CustomDropdown.defaultProps = {
  shrink: true,
  autoComplete: false,
  allowEmpty: false,
  emptyValues: [-1, 'None'],
  disabled: false,
  selectedValue: null,
  defaultValue: null,
};

export default CustomDropdown;
